/**
 * Constrains a number to the inclusive range [minimum, maximum].
 */
export function clamp(value, minimum, maximum) {
  return Math.min(maximum, Math.max(minimum, value));
}

/**
 * Frame-rate independent exponential damping.
 *
 * @param {number} current Current value.
 * @param {number} target Target value.
 * @param {number} lambda Response speed. Higher values converge faster.
 * @param {number} delta Frame delta in seconds.
 */
export function damp(current, target, lambda, delta) {
  return current + (target - current) * (1 - Math.exp(-lambda * delta));
}

/**
 * Returns pointer coordinates normalized to the WebGL convention [-1, 1].
 */
export function normalizePointer(event, element) {
  const bounds = element.getBoundingClientRect();
  return {
    x: ((event.clientX - bounds.left) / bounds.width) * 2 - 1,
    y: -(((event.clientY - bounds.top) / bounds.height) * 2 - 1),
  };
}

/**
 * Deterministic pseudo-random generator used by particle buffers and, later,
 * model generators. Reusing the same seed produces stable particle indexing.
 */
export function createSeededRandom(seed = 1) {
  let state = seed >>> 0;

  return () => {
    state += 0x6d2b79f5;
    let value = state;
    value = Math.imul(value ^ (value >>> 15), value | 1);
    value ^= value + Math.imul(value ^ (value >>> 7), value | 61);
    return ((value ^ (value >>> 14)) >>> 0) / 4294967296;
  };
}
